import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  //bg
  bgColor: '#FFF',
  idBoxBgColor: 'rgba(67, 123, 230, 0.12)',
  homeBgColor: '#F2F4F6',
  navIconBgColor: '#F8F9FA',
  logoutBtnBgColor: '#F2F4F6',
  homeMainBoxBgColor: '#4E5565',
  costBgColor: '#F2F5FF',
  inputOffBgColor: '#CDD4D9',

  //txt
  textDefaultColor: '#333',
  text222Color: '#222',
  textWhiteColor: '#FFF',
  textAAAColor: '#AAAAAA',
  textBlackColor: '#000',
  textOrderColor: '#516EA0',

  //btn
  btnBlueColor: '#437BE6',
  btnStrongBlueColor: '#2142AB',

  // searchbox
  searchBoxBorderedColor: '#d6dbe1',
  searchPlaceholderColor: '#CDCDCF',

  //colors
  gray10: '#F9F9F9',
  gray100: '#FAFAFA',
  gray200: '#E9E9E9',
  gray300: '#F0F0F0',
  gray500: '#555',
  gray700: '#CCC',
  gray900: '#999',
  f5f5f5: '#F5F5F5',
  f6f6f6: '#F6F6F6',
  workingTypeColor: '#00FFBA',
  halfWorkingTypeColor: 'FFB400',
  redColor: '#FF4B00',

  joinLabelColor: '#6B7684',
  placeholderColor: '#BbB6B6',
  errorColor: '#FF5151',
  loginHrColor: '#E0E0E0',
  iconActiveColor: '#191F28',
  menuNavColor: '#B0B8C1',
};
